<app-ice-select-box
  class="additional-sim-select"
  type="checkbox"
  [checkboxTestId]="'sim-row-' + instanceId()"
  [control]="selectionControl"
  [disabled]="selectionControl.disabled"
  [label]="label()"
  [readonly]="readonly()"
  [value]="instanceId()"
>
  @if (activeIcc()) {
    <div header>ICC: {{ activeIcc() }}</div>
  }

  @if (service().price) {
    <div class="price" inlineHeaderContent>
      {{ monthlyPrice() | priceFormat: PriceType.Monthly }}
    </div>
  }

  @if (isSelected && !isActive()) {
    <div class="icc-content">
      <div class="icc-input-infotext">(Bruker fysisk SIM-kort)</div>

      <p class="sim-delivery-title">Hvordan får kunden SIM-kortet?</p>
      <div class="sim-delivery-options">
        <app-ice-radio-button
          formControlName="simDelivery"
          label="Levert i butikk"
          ngDefaultControl
          [forId]="'simDelivery-in-store-' + instanceId()"
          [isBoxVersion]="true"
          [testId]="'sim-delivery-in-store-' + instanceId()"
          [value]="SimCardDelivery.InStore"
        />
        <app-ice-radio-button
          formControlName="simDelivery"
          label="Sendt i posten"
          ngDefaultControl
          [forId]="'simDelivery-by-mail-' + instanceId()"
          [isBoxVersion]="true"
          [testId]="'sim-delivery-by-mail-' + instanceId()"
          [value]="SimCardDelivery.ByMail"
        />
      </div>

      @if (isDeliveredInStore) {
        <app-ice-input-field
          formControlName="icc"
          inputWidth="medium"
          label="SIM-nummer"
          maxlength="20"
          minlength="19"
          ngDefaultControl
          placeholder="Scan eller skriv inn SIM-nummeret"
          [errorOnTouchedOnly]="true"
          [errorText]="getSimCardErrorTexts(iccField?.errors, simCardType())"
          [forId]="'icc-' + instanceId()"
          [textTestId]="'icc-input-' + instanceId()"
        />
        @if ((iccField?.statusChanges | async) === FormStatus.PENDING) {
          <app-spinner />
        }
      }
    </div>
  }
</app-ice-select-box>
